/* ==========================================================================
   Blinq · Shop essentials (sections/blinq-essentials.liquid)
   Arrows for the card row: scroll one card at a time, and grey out at the
   ends. Swipe / trackpad scrolling is the browser's own (scroll-snap).
   On phones the cards are a grid and the arrows are hidden.
   ========================================================================== */
(() => {
  const init = (root) => {
    if (!root || root.dataset.bessReady) return;
    root.dataset.bessReady = 'true';
    const track = root.querySelector('[data-bess-track]');
    const prev = root.querySelector('[data-bess-arrow="-1"]');
    const next = root.querySelector('[data-bess-arrow="1"]');
    if (!track || !prev || !next) return;

    const step = () => {
      const item = track.querySelector('.bess__item');
      if (!item) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
      root.classList.toggle('is-static', max <= 2);
    };
    const go = (dir) => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    };
    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    else window.addEventListener('resize', update);
    update();

    /* Theme editor: bring the selected card into view */
    root.addEventListener('shopify:block:select', (e) => {
      const item = e.target.closest('.bess__item');
      if (item) track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    });
  };

  const initAll = (scope) => (scope || document).querySelectorAll('[data-bess]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();